// @flow

import React, { type Node } from 'react';
import { TitleCell, ResponsiveCell } from './cell';
import Row, { ResponsiveRow } from './row';

type Props = {
  label: string,
  responsiveColspan?: ?number, // eslint-disable-line react/require-default-props
  children: Array<Node> | Node,
};

const ResponsiveTableRow = ({
  label,
  responsiveColspan,
  children,
}: Props) => (
  <>
    <ResponsiveRow>
      <TitleCell colSpan={responsiveColspan}>{label}</TitleCell>
    </ResponsiveRow>
    <Row>
      <ResponsiveCell>{label}</ResponsiveCell>
      {children}
    </Row>
  </>
);

export default ResponsiveTableRow;
